export default "assets/images/line-85f3aec1.svg";